module.exports = __webpack_public_path__ + "static/media/aliface.1e4cdd09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profiles/aliface.png
// module id = 128
// module chunks = 0